import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {PickupPoliciesContent} from "@/customComponents/globalComponents/policiesContent.jsx";

// Content lives in globalComponents/policiesContent.jsx (static copy).
export {PickupPoliciesContent};

export function PickupPolicies({setStep, closeModal, previousStep}) {
    const backStep = previousStep || (storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing");
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={backStep} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <PickupPoliciesContent/>
        </>
    );
}
export default PickupPolicies;
